import React, {FC, memo, useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions as modal} from "../../store/sliceModal";
import {KettleArticle, KettleImg, KettleTextDegree, KettleTextStatus} from "./KettleStyle";
import kettleImg from "../../image/kettle.jpg"
import {kettleModeToText} from "../../utils/Util";


const Kettle: FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const {temperature, mode, connection, setPointTemperature} = useSelector((state: IRootState) => state.websocket.kettle)

    const status = useCallback((): string => {
        // switch (mode) {
        //     case 0: return "Онлайн"
        //     case 1: return "Кипячение"
        //     case 3: return `Разогрев до ${setPointTemperature} °C`
        //     case 4: return `Поддержка ${setPointTemperature} °C`
        //     case 5: return "IQ кипячение"
        //     default: return mode
        // }
        // if (!connection) {
        //     return "Оффлайн"
        // }
        return kettleModeToText(mode, connection, setPointTemperature)

    }, [mode, setPointTemperature, connection])

    const statusTemperature = useCallback((): string => {
        if (!connection) {
            return "-- °C"
        } else {
            return `${temperature} °C`
        }
    }, [temperature, connection])


    return (
        <KettleArticle onClick={() => dispatch(modal.showKettleModal())}>
            <KettleImg src={kettleImg} alt={"Чайник"}/>
            <KettleTextDegree>
                {statusTemperature()}
            </KettleTextDegree>
        <KettleTextStatus>
            {status()}
        </KettleTextStatus>
        </KettleArticle>

    )
}


export default memo(Kettle)

